/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:15:36
 * @LastEditors: dongjing
 * @LastEditTime: 2019-12-13 21:08:00
 */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import homeReducer from '@features/home/redux/reducer';
import commonReducer from '@features/common/redux/reducer';
import searchReducer from '@features/search/redux/reducer';
import personalReducer from '@features/personal/redux/reducer';
import articleReducer from '@features/article/redux/reducer';
import articlesReducer from '@features/articles/redux/reducer';
import messageReducer from '@features/message/redux/reducer';
import askReducer from '@features/ask/redux/reducer';
import tagReducer from '@features/tag/redux/reducer';
import circleReducer from '@features/circle/redux/reducer';
import teamReducer from '@features/team/redux/reducer';
import voteReducer from '@features/vote/redux/reducer';
import adminReducer from '@features/admin/redux/reducer';
import activeReducer from '@features/active/redux/reducer';
import mallReducer from '@features/mall/redux/reducer';
import thematicReducer from '@features/thematic/redux/reducer';
import history from './history';

export const reducerMap = {
  router: connectRouter(history),
  home: homeReducer,
  common: commonReducer,
  search: searchReducer,
  personal: personalReducer,
  article: articleReducer,
  articles: articlesReducer,
  message: messageReducer,
  ask: askReducer,
  tag: tagReducer,
  circle: circleReducer,
  team: teamReducer,
  vote: voteReducer,
  admin: adminReducer,
  active: activeReducer,
  mall: mallReducer,
  thematic: thematicReducer
};

export type RootReducerMap = typeof reducerMap;
export type RootReducerMapKey = keyof RootReducerMap;
export default combineReducers(reducerMap);
